import api, { ResponsePayloadWithData } from '../../../api';
import { Group, Member } from '../../../api/groups';
import { School, SchoolResponse } from '../../../api/schools';
import { SchoolYear } from '../context/MyGroupsContext';

type CreateGroupRequestPayload = {
  schoolYear: SchoolYear;
  name: string;
  school: {
    id: string;
    isSmartschool: boolean;
  };
  subjects: string[];
};

export async function createGroup({ name, school, schoolYear, subjects }: CreateGroupRequestPayload): Promise<Group> {
  const { data } = await api.post<Group>(
    `/studio/user/school-years/${schoolYear.startYear}-${schoolYear.endYear}/groups`,
    {
      name,
      school,
      subjects,
    },
    { params: { studioGroup: process.env.REACT_APP_P_STUDIO_GROUP } },
  );

  return data;
}

export async function fetchSchools(search?: string): Promise<School[]> {
  const {
    data: { data },
  } = await api.get<ResponsePayloadWithData<SchoolResponse[]>>('/studio/schools', { params: { search } });

  return data.map(x => ({ ...x, isSmartschool: false }));
}

export type Subject = {
  id: string;
  name: string;
  slug: string;
  published: boolean;
};

export async function fetchSubjects() {
  const {
    data: { data },
  } = await api.get<ResponsePayloadWithData<Subject[]>>('/studio/subjects/sanitized', {
    params: { group: process.env.REACT_APP_P_STUDIO_GROUP },
  });

  return data;
}

export async function renameGroup(schoolYear: SchoolYear, groupId: string, name: string): Promise<Group> {
  const { data } = await api.patch<Group>(
    `studio/user/school-years/${schoolYear.startYear}-${schoolYear.endYear}/groups/${groupId}`,
    { name },
  );

  return data;
}

export async function deleteGroup(schoolYear: SchoolYear, groupId: string): Promise<void> {
  await api.delete(`studio/user/school-years/${schoolYear.startYear}-${schoolYear.endYear}/groups/${groupId}`);
}

export async function getAssignmentsCountForGroup(schoolYear: SchoolYear, groupId: string): Promise<number> {
  const {
    data: {
      data: { count },
    },
  } = await api.get<ResponsePayloadWithData<{ count: number }>>(
    `studio/user/school-years/${schoolYear.startYear}-${schoolYear.endYear}/groups/${groupId}/assignments/count`,
  );

  return count;
}

export async function fetchSmartschoolMembers(schoolYear: SchoolYear, groupId: string): Promise<Member[]> {
  const {
    data: { data },
  } = await api.get<ResponsePayloadWithData<Member[]>>(
    `studio/user/school-years/${schoolYear.startYear}-${schoolYear.endYear}/groups/${groupId}/smartschool-members`,
  );

  return data;
}
